import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import PuzzleIcon from "@images/puzzle.svg"
import TwoColumnIconTextCombo from "@modules/TwoColumns/TwoColumnIconTextCombo"
import CaseStudyBackgroundDesktop from "@images/caseStudyBackgroundDesktop.svg"
import CaseStudyBackgroundMobile from "@images/caseStudyBackgroundMobile.svg"
import { useBreakpoints } from "@hooks/useBreakpoints"

const ConsumerRecycleSupply = () => {
  const { t } = useTranslation()
  const { isDesktop } = useBreakpoints()
  return (
    <TwoColumnIconTextCombo
      theme="blue"
      col1content={{
        icon: PuzzleIcon,
        label: t("SubheaderTag_Solution"),
        title: t("CaseStudyCompetitive_Subheader3"),
        arrtext: [
          t("CaseStudyCompetitive_Paragraph4"),
        ],
        img: null,
      }}
      col2content={{
        arrtext: []
      }}
      col1class=""
      col2class=""
      containerClass=""
      reverse={false}
      backgroundImage={
        isDesktop ? CaseStudyBackgroundDesktop : CaseStudyBackgroundMobile
      }
      backgroundStyle={{
        backgroundPosition: isDesktop ? "bottom right" : "top right",
      }}
    />
  )
}

export default ConsumerRecycleSupply
